<template>
    <div v-if="isAccepted" class="conversion-overview">
        <div v-if="quote.commercialRate !== null" class="h-text-area">
            <span class="conversion-overview__text" tabindex="0">{{ $ml.get('dccCommercialRateLabel') }}</span>
            <span class="conversion-overview__value">{{ formattedCommercialRate }}</span>
        </div>

        <div class="h-text-area">
            <span class="conversion-overview__text" tabindex="0">{{ $ml.get('dccAppliedMarkupLabel') }}</span>
            <span class="conversion-overview__value">{{ formattedMarkup }}</span>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';
import moneyHelper from '@/helpers/moneyHelper';

const ORDER_CURRENCY_CODE = 'BRL';
const RATE_DECIMALS = 6;

export default {
    name: 'ConversionOverview',

    computed: {
        ...mapGetters({
            isAccepted: 'dcc/getIsAccepted',
            quote: 'dcc/getQuote',
            currency: 'dcc/getCurrencyPresentation'
        }),

        /**
         * Câmbio comercial pode não vir na cotação. Nesse caso a linha não é exibida.
         */
        formattedCommercialRate: (self) => self.buildRateText(self.quote.commercialRate),

        formattedMarkup: (self) => `${moneyHelper.formatToPercent(self.quote.markupPercent)}% aplicado`,
    },

    methods: {
        /**
         * A cotação já devolve a taxa na direção "1 BRL = X <moeda>" — só formata.
         */
        buildRateText(rate) {
            return `1 ${ORDER_CURRENCY_CODE} = ${moneyHelper.formatToRate(rate, RATE_DECIMALS)} ${this.currency.code}`;
        },
    },
};
</script>

<style scoped lang="scss">
.conversion-overview {
    &__text,
    &__value {
        font-size: 16px;
        font-weight: 500;
        color: #5C6A7B;
    }

    // Definida aqui de propósito: o scoped do TotalizerOverview não atravessa para dentro
    // deste componente, então a regra dele não chega até estas divs — mesmo padrão que
    // DiscountOverview e ConvenienceFeeOverview já seguem, cada um com a própria regra.
    .h-text-area {
        display: flex;
        justify-content: space-between;

        &:not(:last-child) {
            margin-bottom: 8px;
        }
    }
}
</style>
